<script>
import EgCard from "@/components/global/eg_card.vue";
import EgButton from "@/components/global/eg/buttons/eg_button.vue";
import { capitalizeEachWord } from "@/utils/capitalize";

export default {
  name: "PricingCard",

  components: {
    EgCard,
    EgButton,
  },

  props: {
    planId: {
      type: String,
      required: true,
    },
    planName: {
      type: String,
      required: true,
    },
    planPrice: {
      type: String,
      required: true,
    },
    planDescription: {
      type: String,
      required: true,
    },
    discountPercent: {
      type: Number,
      default: null,
    },
    featuresHeading: {
      type: String,
      default: "Everything in Pro Plus:",
    },
    features: {
      type: Array,
      default: () => [],
    },
    button: {
      type: Object,
      default: () => ({
        text: "Select Plan",
        icon: null,
      }),
    },
    yearlyToggle: {
      type: Boolean,
      default: true,
    },
    isSubscribed: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      animatedPrice: 0,
      animationId: null,
      isAnimating: false,
      isLoading: false,
    };
  },

  computed: {
    isPopular() {
      return this.planId === "pro";
    },

    hasDiscount() {
      return this.discountPercent && this.discountPercent > 0;
    },

    // numericPrice() {
    //   const priceStr = this.planPrice.replace(/[^0-9.]/g, "");
    //   return parseFloat(priceStr) || 0;
    // },
  },

  /*watch: {
    planPrice: {
      handler(newPrice, oldPrice) {
        if (oldPrice && newPrice !== oldPrice) {
          // this.animatePriceChange();
        }
      },
      immediate: true,
    },
  },

  mounted() {
    this.animatedPrice = this.numericPrice;
  },

  beforeDestroy() {
    if (this.animationId) {
      cancelAnimationFrame(this.animationId);
    }
  },
*/
  methods: {
    capitalizeEachWord,

    // animatePriceChange() {
    //   if (this.isAnimating) {
    //     if (this.animationId) {
    //       cancelAnimationFrame(this.animationId);
    //     }
    //   }
    //
    //   const startPrice = this.animatedPrice || 0;
    //   const endPrice = this.numericPrice;
    //   const duration = 800; // ms
    //   const startTime = performance.now();
    //
    //   this.isAnimating = true;
    //
    //   const animate = (currentTime) => {
    //     const elapsed = currentTime - startTime;
    //     const progress = Math.min(elapsed / duration, 1);
    //     const easeProgress = 1 - Math.pow(1 - progress, 4);
    //
    //     this.animatedPrice =
    //       startPrice + (endPrice - startPrice) * easeProgress;
    //
    //     if (progress < 1) {
    //       this.animationId = requestAnimationFrame(animate);
    //     } else {
    //       this.animatedPrice = endPrice;
    //       this.isAnimating = false;
    //       this.animationId = null;
    //     }
    //   };
    //
    //   this.animationId = requestAnimationFrame(animate);
    // },

    formatPrice(price) {
      return price.toFixed(2);
    },

    selectPlan() {
      this.isLoading = true;
      this.$emit("select-plan", {
        planId: this.planId,
        resolve: () => {
          this.isLoading = false;
        },
      });
    },
  },
};
</script>

<template>
  <eg-card class="pricing-card" :class="{ 'popular-card': isPopular }">
    <div v-if="isPopular" class="popular-badge caption-s semi-bold">
      {{ $t("account.popularBadge") }}
    </div>

    <div class="pricing-content">
      <div class="pricing-top">
        <div class="pricing-top-inner">
          <!-- Header Section -->
          <div class="pricing-header">
            <div class="plan-title-section">
              <div class="heading-xs semi-bold">
                {{ capitalizeEachWord(planName) }}
              </div>

              <div
                v-if="hasDiscount && yearlyToggle && isPopular"
                class="discount-badge"
              >
                {{ discountPercent }}% OFF
              </div>
            </div>
          </div>

          <!-- Pricing Details -->
          <div class="pricing-details">
            <div class="price-section">
              <span
                v-if="planId === 'district'"
                class="price heading-m semi-bold"
              >
                {{ $t("account.customPricing") }}
              </span>

              <div v-else>
                <span class="price heading-m semi-bold">
                  $ {{ formatPrice(+planPrice) }}
                </span>
                <span class="price-period paragraph-s">{{
                  $t("account.perMonth")
                }}</span>
              </div>
            </div>
            <div v-if="+planPrice > 0" class="annual-pricing caption-s">
              <div :class="{ transparent: !yearlyToggle }">
                {{
                  $t("account.chargedAnnually", {
                    amount: formatPrice(planPrice * 12),
                  })
                }}
              </div>
            </div>

            <div v-else class="annual-pricing caption-s">
              {{ $t("account.contactUsForPricing") }}
            </div>
          </div>
        </div>

        <!-- Plan Description -->
        <div class="plan-description caption-s">
          <div>{{ planDescription }}</div>
        </div>

        <!-- Call to Action Button -->
        <div class="cta-section">
          <eg-button
            :type="isPopular ? 'primary' : 'secondary'"
            class="w-100"
            :is-loading="isLoading"
            :right-icon="button.icon"
            :disabled="isSubscribed"
            @click="selectPlan"
          >
            {{ isSubscribed ? $t("account.youreSubscribed") : button.text }}
          </eg-button>
        </div>
      </div>

      <div class="separator"></div>

      <!-- Features Section -->
      <div v-if="features.length > 0" class="features-section">
        <div class="features-heading paragraph-s semi-bold">
          {{ featuresHeading }}
        </div>
        <ul class="features-list">
          <li
            v-for="(feature, index) in features"
            :key="index"
            class="feature-item"
          >
            <eg-icon icon="check-circle" class="checkmark-icon" />
            <span class="feature-text caption-s">{{ feature }}</span>
          </li>
        </ul>
      </div>
    </div>
  </eg-card>
</template>

<style scoped lang="scss">
.pricing-card {
  background: white;
  border-radius: 20px;
  padding: 0;
  transition: all 0.3s ease;
  border: 1px solid #f0f0f0;
  position: relative;
  max-width: 324px;
  width: calc(100% / var(--pricing-cards-count));

  &.popular-card {
    border: 1px solid var(--color-stroke-primary-default);
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    background-color: var(--color-surface-primary-light-1);
  }

  .popular-badge {
    background-color: var(--color-surface-primary-default);
    color: white;
    padding: 6px 16px;
    outline: 1px solid var(--color-stroke-primary-default);
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    position: absolute;
    bottom: 100%;
    left: 0;
    width: 100%;
  }

  .pricing-content {
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  &:hover {
    box-shadow: 3px 3px 20px 0px #0000000a;
  }
}

.pricing-top {
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: 215px;
  justify-content: space-between;

  .pricing-top-inner {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
}

.plan-title-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 26px;
}

.pricing-details {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.price {
  transition: all 0.1s ease;
}

.price-period {
  color: var(--color-text-neutral-secondary);
}

.annual-pricing {
  color: var(--color-text-neutral-secondary);
}

.plan-description {
  color: var(--color-text-neutral-on-white);
}

.features-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.features-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 12px;
}

.checkmark-icon {
  color: var(--color-icon-neutral-disabled) !important;
}

.transparent {
  opacity: 0;
}
</style>
